export class RegisterLoanBySupplierRequest {
  loanTemplateId: any | undefined;
  customerNationalCode: string | undefined;
  customerBirthDate: string | Date | undefined;
  customerMobileNumber: string | undefined;
  loanAmount: any | undefined;
  postalCode: string | undefined;
  installmentCount?: any;
  installmentDuration: any;
  installmentStepSpace: any | undefined;
  inquiryOtp?: string | undefined;
  inquiryOtpRefKey?: string | undefined;
  englishFirstName?: string | undefined;
  englishLastName?: string | undefined;
}
export interface RegisterLoanBySupplierResponse {
  isValid: boolean;
  referenceKey?: string;
  validationIssues: string[];
  customerInfo: CustomerInfo;
  inquiryOtpRequired?: boolean;
  inquiryOtpRefKey?: string;
  needActivationLoanOtp: boolean;
}
export class GetCustomerRegistrationInfoRequest {
  nationalCode: string | undefined;
}
export interface GetCustomerRegistrationInfoResponse {
  hasRegisterRequest: boolean;
  isEditable: boolean;
  isCancelable: boolean;
  step: string;
  stepTitle: string;
  stepNumber: number;
  backStep: string;
  backStepNumber: number;
  customerInfo: CustomerInfo;
  loanTemplateInfos: LoanTemplateInfo[];
  existingLoanRequest: ExistingLoanRequest;
  needActivationLoanOtp: boolean;
}
export class CustomerInfo {
  id?: number;
  nationalCode?: string;
  cellPhone?: string;
  phoneNumber?: string;
  firstName?: string;
  lastName?: string;
  fatherName?: string;
  birthDate?: Date;
  birthDatePersian?: string;
  birthDate_Persian?: string;
  genderTypeId?: number;
  email?: string;
  postalCode?: string;
  address?: string;
  cityId?: string;
  idSeri?: number;
  idSerial?: number;
  installmentCount?: number;
  gender?: string;
  hasAccount?: boolean;
  shenasnamehNumber?: string;
  englishFirstName?: string;
  englishLastName?: string;
}
export interface LoanTemplateInfo {
  isBySupplierCredit: boolean;
  id: number;
  financialSupplierName: string;
  financialSupplierTitle: string;
  expirationDate: Date;
  expirationDate_Persian: string;
  title: string;
  minAmount: number;
  maxAmount: number;
  profitPercentage: number;
  description: string;
  installmentStep: InstallmentStep[];
  supplierCredit: number;
  cardImage: string;
  registrationRequestId: number;
  digitallSignRequired: boolean;
}
export interface InstallmentStep {
  stepSpaceByMonth: number;
  installmentCount: number;
  key: string;
}
export interface ExistingLoanRequest {
  loanRequestId: number;
  loanTemplateId: number;
  finalLoanAmount: number;
  finalStepSpaceByMonth: number;
  finalInstallmentCount: number;
  referenceKey: string;
  loanRequestStatus: string;
  needGuaranteeCheque: boolean;
  needInstallmentCheques: boolean;
  guaranteeChequeCompleted: boolean;
  installmentChequesCompleted: boolean;
  finalInstallmentDuration: number;
}

export class ReferenceKeyRequest {
  referenceKey: string | undefined;
  activationOtp?: string | undefined;
}

export interface ActivateLoanRequestBySupplierResponse {
  isValid: boolean;
  loanRequestId: number;
  validationIssues: string[];
}
export class GetSupplierAttachmentsRequest {
  id: number | undefined;
}

export interface UploadSupplierAttachmentResponse {
  fileId: string;
  fileName: string;
  documentType: string;
  fileType: string;
  fileUrl: string;
  documentTypeTitle: string;
}
export class DeleteSupplierAttachmentRequest {
  loanRequestId: number | undefined;
  fileAttachmentId: string | undefined;
}

export class UploadSupplierAttachmentRequest {
  LoanRequestId: number | undefined;
  DocumentType: string | undefined;
  FileName: string | undefined;
  FileData: File | undefined;
  FactorNumber: string | undefined;
}

export class GetLoanDetailRequest {
  id: number | undefined;
}
export interface GetLoanDetailResponse {
  isEditable: boolean;
  loanRequestId: number;
  customerFirstName: string;
  customerLastName: string;
  customerFullName: string;
  customerAddress: string;
  customerPostalCode: string;
  customerNationalCode: string;
  customerMobileNumber: string;
  supplierName: string;
  factorNumber: string;
  requestDatePersian: string;
  settlementDatePersian: string;
  bankApproveDatePersian: string;
  installmentCount: number;
  installmentAmount: number;
  loanAmount: number;
  profitRate: number;
  loanRequestStatus: string;
  loanRequestStatusTitle: string;
  supplierSettlementStatus: string;
  supplierSettlementStatusTitle: string;
  birthDatePersian: string;
  loanRequestStatusColor: string;
  supplierSettlementStatusColor: string;
  loanTemplateId: number;
  loanTemplateTitle: string;
  referenceKey: string;
  loanRequestSourceTitle: string;
  supplierUserTitle: string;
  supplierUserId: number;
  financialSupplierTitle: string;
  supplierMobileNumber: string;
  registrationRequestId: number;
}
export class GetLoansRequest {
  paginationInfo: PaginationInfo | undefined;
  filter: Filter | undefined;
}
export class PaginationInfo {
  pageNumber: number | undefined;
  pageSize?: number = 10;
}
export class Filter {
  loanRequestId: number | undefined;
  customerNationalCode: string | undefined;
  customerFullName: string | undefined;
  referenceKey: string | undefined;
  // requestDate: string | undefined;
  requestDateFrom: string | undefined;
  requestDateTo: string | undefined;
  loanRequestStatus: string[] | undefined;
  supplierSettlementStatus: string[] | undefined;
  loanTemplateIds: string[] | undefined;
  valueLoanTemplate: string[] | undefined;
  loanRequestSources: string[] | undefined;
  supplierUserIds: string[] | undefined;
  // requestDatePersian: string | undefined;
  requestDateArray: Date[] | null | undefined;
  sayadNumber?: string | undefined;
  ////////////////new
  name: string | undefined;
  nationalCode: string | undefined;
  phoneNumber: string | undefined;
  branchName: string | undefined;
  iBan: string | undefined;
  iBanOwner: string | undefined;
  paymentDate: Date | undefined;
  paymentDatePersian: string | undefined;
  factorAmount: string | undefined;
  requestDate: Date | undefined;
  requestDatePersian: string | undefined;
  saleId: number | undefined;
  state: string | undefined;
  branchId: number | undefined;
  customerPersonId: number | undefined;
}
export class FilterFinder {
  state: string | undefined;
  rowNumber: number | undefined;
  pageNumber: number | undefined;
}

export interface CancelLoanRequestBySupplierRequest {}
export interface SendLoanActivationCodeToCustomerResponse {
  isValid: boolean;
  validationIssues: string[];
}
//new register
export interface GetLoanRegistrationWizardInfoResponse {
  currentStatus: string;
  currentStatusTitle: string;
  tabs: Tab[];
  loanRequestInfo: LoanRequestInfo;
}

export interface Tab {
  key: string;
  title: string;
  requiredDocuments: RequiredDocument[];
  hints: string[];
  errors: Error[];
}

export interface RequiredDocument {
  id: number;
  title: string;
  enumData: string;
  maxSize_KB: number;
  orderIndex: number;
  fileType: string;
  documentGroupId: number;
  documentGroup: string;
  documentGroupTitle: string;
}

export interface Error {
  errorMessage: string;
  entityId: number;
}

export interface LoanRequestInfo {
  isEditable: boolean;
  loanRequestId: number;
  customerFirstName: string;
  customerLastName: string;
  customerFullName: string;
  customerAddress: string;
  customerPostalCode: string;
  customerNationalCode: string;
  customerMobileNumber: string;
  supplierName: string;
  factorNumber: string;
  requestDate: string;
  requestDatePersian: string;
  settlementDate: string;
  settlementDatePersian: string;
  bankApproveDate: string;
  bankApproveDatePersian: string;
  installmentCount: number;
  installmentDuration: number;
  installmentAmount: number;
  loanAmount: number;
  profitRate: number;
  loanRequestStatus: string;
  supplierSettlementStatus: string;
  supplierSettlementStatusTitle: string;
  supplierSettlementStatusColor: string;
  loanRequestStatusTitle: string;
  loanRequestStatusColor: string;
  birthDate: string;
  birthDatePersian: string;
  supplierMobileNumber: string;
  referenceKey: string;
  loanTemplateId: number;
  loanTemplateTitle: string;
  loanRequestSourceTitle: string;
  supplierUserTitle: string;
  supplierUserId: number;
  financialSupplierTitle: string;
  needGuaranteeCheque: boolean;
  needInstallmentCheques: boolean;
  loanRequestSource: string;
  loanRequestStatusUpdateDate: string;
  loanRequestStatusUpdateDatePersian: string;
  stepSpace: number;
  warrantyPercentage: number;
  registrationRequestId: number;
  minRepaymentPower: number;
  warrantyAmount: number;
  englishFirstName: string;
  englishLastName: string;
  digitallSignRequired: boolean;
}

export class CancelReason {
  referenceKey: string | undefined;
  reasonIds: number[] | undefined;
  reasonDetail: string | undefined;
}

export interface GetCoreInformationResponse {
  tabKeys: string[];
  loanRequestInfo: LoanRequestInfo;
  installmentCheques: InfoCheque[];
  guarenteeCheque: InfoCheque;
  contract: DocumentUrl[];
  address: Address;
  identityDocuments: DocumentUrl[];
  incomes: Income[];
  otherDocuments: DocumentUrl[];
  cartableHistory: CartableHistory[];
}
export interface InfoCheque {
  referenceKey: string;
  chequeId: number;
  amount: number;
  amountAlphabet?: string;
  dueDate: string;
  dueDatePersian: string;
  fileId: string;
  rearFileId?: string;
  expectedHolder?: string;
  expectedIdCode?: string;
  chequeType: string;
  sayadNumber: string;
  signer: string;
  idCode: string;
  serialNo: string;
  seriesNo: string;
  fromIban: string;
  branchCode: string;
  bankName: string;
  file: DocumentUrl;
  rearFile: DocumentUrl;
  isAccumulative: boolean;
  accumulativeAmount: number;
  inquiryAmount: number;
  inquiryDueDatePersian: string;
  inquiryDueDate: string;
  reasonTitle: string;
}
export interface Address {
  id: number;
  personId: number;
  provinceId: number;
  provinceTitle: string;
  cityId: number;
  cityTitle: string;
  postalCode: string;
  addressInfo: string;
  documentUrls: DocumentUrl[];
  addressByInquiry: string;
  phoneNumber: string;
}
export interface Factor {
  factorKey: string;
  factorDate: string;
  factorDate_Persian: string;
  deliveryDate: string;
  deliveryDate_Persian: string;
  factorNumber: string;
  factorFile: DocumentUrl;
  deliveryReceiptFile: DocumentUrl;
  items: Item[];
  factorFileId: string;
  deliveryReceiptFileId: string;
  factorId: number;
}

export interface Item {
  referenceKey: string;
  factorItemId: number;
  factorKey: string;
  quantity: number;
  title: string;
  unitPrice: number;
  offAmount: number;
}
export interface Income {
  id: number;
  incomeType: string;
  incomeTypeTitle: string;
  jobTitle: string;
  organizationTitle: string;
  phoneNumber: string;
  address: string;
  amount: number;
  description: string;
  creationDate: string;
  creationDatePersian: string;
  filesUrls: DocumentUrl[];
}
export interface CartableHistory {
  workflowType: string;
  workflowTypeTitle: string;
  workflowStepType: string;
  actionDate: string;
  actionDatePersian: string;
  actionTitle: string;
  userTitle: string;
  userData: Userdata[];
}
export interface Userdata {
  key: string;
  value: string;
}

export interface DocumentUrl {
  id: number;
  key?: string | undefined;
  fileId: string;
  fileName: string;
  documentType: string;
  documentTypeTitle: string;
  fileType: string;
  fileUrl: string;
  fileData?: File | undefined;
}
